export const themeColors = {
    primary: {
        danaBlue: "#0071AD",
        white: "#FFFFFF",
        richBlack: "#000000",
        black: "#212121",
    },
    secondary: {
        danaBrightBlue: "#00A8FF",
        danaDarkBlue: "#00389D",
    },
    danger: "#C00",
    success: "#27A74A",
    warning: "#FEC111",
    successGreen: "#39A200",
    successBannerBg: "#eaf6ee",
    successBannerBorder: "#7dcf9c",
    warningBannerBg: "#fef6ec",
    warningBannerBorder: "#f5c18a",
    warningBannerText: "#7a4010"
};

export const gradients = {
    danaBlueGradient: `linear-gradient(180deg, ${themeColors.secondary.danaDarkBlue} 29.81%, ${themeColors.primary.danaBlue} 100%)`,
};

export const themeBackgrounds = {
    black: "#212121",
    darkGray: "#535353",
    lightGray: "#DEDEDE",
    offWhite: "#F3F3F3",
    white: "#FFFFFF",
    badgeYellow: "#ff0",
    success: "#F0FFF4",
    danger: "#fdf0ee",
    available:"#0fce48",
    notAvailable:"#ff0505"
};

export const elevation = {
    focus: `0px 0px 0px 1px ${themeColors.secondary.danaDarkBlue}`,
    hover: `0px 4px 12px 0px rgba(0, 0, 0, 0.20)`,
};
